/**
 * Set video controls list to disable download, remote playback, playback rate change, picture-in-picture and context menu
 */
export default function setVideoControlsList() {
    
    let videos = document.querySelectorAll('video');
    
    videos.forEach(video => {
        video.setAttribute('controlsList', 'nodownload noremoteplayback noplaybackrate');
        video.setAttribute('disablepictureinpicture', '');
        video.addEventListener('contextmenu', function(e){ e.preventDefault(); });
        video.addEventListener('dragstart', function(e){ e.preventDefault(); });
    });
    
}
